import { bindable, useView } from "aurelia-framework";

@useView('views/pages/admin/onboarding/steps/onboarding-whats-needed/onboarding-whats-needed.html')
export class OnboardingWhatsNeeded {
	
	@bindable
	public icon: string;

	@bindable
	public title: string;

	@bindable
	public descriptionHtml: string;
}
